/**
 * Register Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Register template.
 *
 */

// Scripts
import $ from "jquery";
import "sections/header/header";
import "sections/footer/footer";
import "sections/page-header/page-header";

// Styles
import "./_register.scss";

// Handle submit button enablement
document.addEventListener("DOMContentLoaded", () => {
    const password = document.querySelector("#CreatePassword");
    const submitButton = document.querySelector(
        '.form--register input[type="submit"]',
    );

    // Disable submit button on Register
    if (window.location.pathname === "/account/register") {
        submitButton.disabled = true;
    }

    const passwordLengthIsValid = () =>
        password.value.length >= 5 && password.value.length <= 40
            ? true
            : false;

    const inputsAreFilled = () => {
        const inputs = document.querySelectorAll(
            ".form--register .form__input--button-state",
        );

        for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].value.length === 0) return false;
        }

        return true;
    };

    document
        .querySelectorAll(".form--register .form__input--button-state")
        .forEach((input) => {
            input.addEventListener("input", () => {
                if (inputsAreFilled() && passwordLengthIsValid()) {
                    submitButton.disabled = false;
                } else {
                    submitButton.disabled = true;
                }
            });
        });
});
